export enum EStatusAssinatura {
    Ativa = 1,
    Teste = 2,
    Vencida = 3,
    Cancelada = 4,
    Suspensa = 5,
    NaoImplantada = 6,
}
